import { makeStyles, tokens } from '@fluentui/react-components';

export const useFooterStyles = makeStyles({
  footer: {
    minHeight: '40px',
    backgroundColor: tokens.colorNeutralBackground2,
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '24px',
    alignItems: 'center',
  },
  link: {
    marginRight: '40px',
    textDecorationLine: 'underline',
  },
});
